import React, { useEffect, useState, useContext } from "react"
import { apiEndpoint } from "helpers/url_helper";

import { Link } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";
import {VehicleDataContext} from "components/Common/PageDataContext";
import {
  Col,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"

const EditVehicleDataModalComponent  = (props) => {
  const {vehicledetails, setVehicleData } = useContext(VehicleDataContext);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [VehicleEditedDetails, setVehicleDetailsInputs] = useState(props.VehicleCurrentRowData);
  const [alertmsg, setAlert] = useState();

  const handleEditChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setVehicleDetailsInputs(values => ({...values, [name]: value}))
  }

  const toggle = () => {

    setModalIsOpen(!modalIsOpen)
  }
  const SaveVehicleData = () => {

    // UserValidated
    fetch(apiEndpoint+"/UpdateVehicleData",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "VehicleID": VehicleEditedDetails.VehicleID,
          "VehicleOwnerName": VehicleEditedDetails.VehicleOwnerName,
          "VehicleRegistrationNumber": VehicleEditedDetails.VehicleRegistrationNumber,
          "VehicleOwnerEmailAddress": VehicleEditedDetails.VehicleOwnerEmailAddress,
          "VehicleOwnerContact": VehicleEditedDetails.VehicleOwnerContact,
          "VehicleOwnerAddress": VehicleEditedDetails.VehicleOwnerAddress,
          "VehicleOwnerDept": VehicleEditedDetails.VehicleOwnerDept,
          "EmployeeID": VehicleEditedDetails.EmployeeID,
          "CampusList": VehicleEditedDetails.CampusList,
          "Token": sessionStorage.getItem("Clear_AuthUser")
        })
       // body: JSON.stringify({VehicleEditedDetails})
      })

      // const updatedData = await response.json();
      // return updatedData;
      .then(res => res.json())
      .then(
        (result) => {
          if (result != undefined) {
            console.log(result);
            //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
            if (result.VehicleDetail != undefined) {
              setAlert(
                <ReactBSAlert
                  success
                  title="Data Saved Successfully!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="info"
                >
                </ReactBSAlert>
              )

              var VehicleID = JSON.parse(result.VehicleDetail).VehicleID;
              let newdata = vehicledetails.slice();
              let dataindex= newdata.findIndex(someobject => someobject.VehicleID == VehicleID);
              newdata[dataindex].VehicleOwnerName = VehicleEditedDetails.VehicleOwnerName;
              newdata[dataindex].VehicleRegistrationNumber = VehicleEditedDetails.VehicleRegistrationNumber;
              newdata[dataindex].VehicleOwnerEmailAddress = VehicleEditedDetails.VehicleOwnerEmailAddress;
              newdata[dataindex].VehicleOwnerContact = VehicleEditedDetails.VehicleOwnerContact;
              newdata[dataindex].VehicleOwnerAddress = VehicleEditedDetails.VehicleOwnerAddress;
              newdata[dataindex].EmployeeID = VehicleEditedDetails.EmployeeID;
              newdata[dataindex].VehicleOwnerDept = VehicleEditedDetails.VehicleOwnerDept;
              setVehicleData(newdata);
            }
            else {
              setAlert(
                <ReactBSAlert
                  warning
                  //   style={bsAlertStyle}
                  title="Something went wrong!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="warning"
                >
                  {result.Message}
                </ReactBSAlert>
              )
            }
          }
          else {
            setAlert(
              <ReactBSAlert
                warning
                //   style={bsAlertStyle}
                title="Something went wrong!"
                onConfirm={() => setAlert(null)}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="warning"
              >
                {result.Message}
              </ReactBSAlert>
            )
          }
        }
      )
  }

  const DeleteRegisteredVehicle = () => {

    // UserValidated
    fetch(apiEndpoint+"/DeleteVehicleData",
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "VehicleID": VehicleEditedDetails.VehicleID,
          "Token": sessionStorage.getItem("Clear_AuthUser")
        })
      })
      .then(res => res.json())
      .then(
        (result) => {
          if (result != undefined) {
            //console.log(result);
            if (result.VehicleDetails != undefined) {
              setAlert(
                <ReactBSAlert
                  success
                  title="Record Deleted Successfully!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="info"
                >
                </ReactBSAlert>
              )

              var recdID = JSON.parse(result.VehicleDetails).VehicleID;
              let newdata = vehicledetails.slice();
              var elindex=newdata.findIndex(someobject => someobject.VehicleID == recdID);
             
              newdata.splice(elindex, 1);
              setVehicleData(newdata);
            }
            else {
              setAlert(
                <ReactBSAlert
                  warning
                  //   style={bsAlertStyle}
                  title="Something went wrong!"
                  onConfirm={() => setAlert(null)}
                  onCancel={() => setAlert(null)}
                  confirmBtnBsStyle="warning"
                >
                  {result.Message}
                </ReactBSAlert>
              )
            }
          }
          else {
            setAlert(
              <ReactBSAlert
                warning
                //   style={bsAlertStyle}
                title="Something went wrong!"
                onConfirm={() => setAlert(null)}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="warning"
              >
                {result.Message}
              </ReactBSAlert>
            )
          }
        }
      )
  }

  return (
    <>
      <Link to='#'
        onClick={toggle}><i className="mdi mdi-border-color mdi-24px"></i></Link>
       {modalIsOpen==true }
       {/* {modalIsOpen==true && alertmsg} */}

      {props.VehicleCurrentRowData != undefined &&
        <Modal isOpen={modalIsOpen} style={{ maxWidth: "60%" }}>

          <ModalHeader toggle={toggle} tag="h4">
            Edit Vehicle Details
          </ModalHeader>
          <ModalBody>
            <AvForm className="needs-validation">
              
              <Row>

                <Col md={12}>
                  <label for="VehicleOwnerName" className="mt-3">Owner Name</label>
                  <AvField
                    name="VehicleOwnerName"
                    placeholder="Owner Name"
                    type="text"
                    className="form-control"
                    defaultValue={props.VehicleCurrentRowData.VehicleOwnerName}
                    id="VehicleOwnerName"
                    onChange={handleEditChange}
                  />
                </Col>
                <Col md={12}>
                  <label for="EmployeeID" className="mt-3">Employee ID</label>
                  <AvField
                    name="EmployeeID"
                    placeholder="Employee ID"
                    type="text"
                    className="form-control"
                    defaultValue={props.VehicleCurrentRowData.EmployeeID}
                    id="EmployeeID"
                    onChange={handleEditChange}
                  />
                </Col>
                <Col md={12}>
                  <label for="VehicleRegistrationNumber" className="mt-3">Registration Number</label>
                  <AvField
                    name="VehicleRegistrationNumber"
                    placeholder="Registration Number"
                    type="text"
                    className="form-control"
                    defaultValue={props.VehicleCurrentRowData.VehicleRegistrationNumber}
                    id="VehicleRegistrationNumber"
                    onChange={handleEditChange}
                  />
                </Col>
                <Col md={12}>
                  <label for="VehicleOwnerDept" className="mt-3">Owner Department</label>
                  <AvField
                    name="VehicleOwnerDept"
                    placeholder="Owner Department"
                    type="text"
                    className="form-control"
                    defaultValue={props.VehicleCurrentRowData.VehicleOwnerDept}
                    id="VehicleOwnerDept"
                    onChange={handleEditChange}
                  />
                </Col>
                <Col md={12}>
                  <label for="VehicleOwnerEmailAddress" className="mt-3">Owner Email ID</label>
                  <AvField
                    name="VehicleOwnerEmailAddress"
                    placeholder="Owner Email ID"
                    type="text"
                    className="form-control"
                    defaultValue={props.VehicleCurrentRowData.VehicleOwnerEmailAddress}
                    id="VehicleOwnerEmailAddress"
                    onChange={handleEditChange}
                  />
                </Col>
                <Col md={12}>
                  <label for="VehicleOwnerContact" className="mt-3">Owner Contact Number</label>
                  <AvField
                    name="VehicleOwnerContact"
                    placeholder="Owner Contact Number"
                    type="text"
                    className="form-control"
                    defaultValue={props.VehicleCurrentRowData.VehicleOwnerContact}
                    id="VehicleOwnerContact"
                    onChange={handleEditChange}
                  />
                </Col>
                <Col md={12}>
                  <label for="VehicleOwnerAddress" className="mt-3">Owner Address</label>
                  <AvField
                    name="VehicleOwnerAddress"
                    placeholder="Owner Address"
                    type="text"
                    className="form-control"
                    defaultValue={props.VehicleCurrentRowData.VehicleOwnerAddress}
                    id="VehicleOwnerAddress"
                    onChange={handleEditChange}
                  />
                </Col>
                <Col md={4} >
                <Link className=" form-control btn btn-primary waves-effect waves-light mt-1"
                    to="#" role="Button" id="deleteBtn"  onClick={() => {
                      DeleteRegisteredVehicle();
                      toggle();
                    }}>Delete</Link>
                </Col>
                <Col md={4}>
                  <Link className=" form-control btn btn-primary waves-effect waves-light mt-1"
                    to="#" role="Button" id="saveBtn"
                    onClick={() => {
                      SaveVehicleData();
                      toggle();
                    }} >Save</Link>

                </Col>
              </Row>
            </AvForm>
          </ModalBody>

        </Modal>
        
      }
          {alertmsg }
    </>

    
  )

}


export default EditVehicleDataModalComponent;